import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "block truncate" }
const _hoisted_3 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }

import { computed } from "vue";
import { ChevronUpDownIcon } from "@heroicons/vue/20/solid";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TreeSelectInputComponent',
  props: {
  context: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



function handleChange(value: string) {
  props.context.node.input(value);
}

// Get the generic options passed from FormKit props
const options = computed(() => props.context.selectOptions || []);

const includeAll = computed(() => props.context?.attrs?.includeAll !== false);

// This computed property now searches the generic options structure
const selectedLabel = computed(() => {
  const currentValue = props.context._value;

  if (!currentValue) {
    return includeAll.value ? 'All' : '';
  }

  for (const group of options.value) {
    if (group.groupValue === currentValue) {
      return group.groupLabel;
    }
    const foundItem = group.items.find((item: any) => item.value === currentValue);
    if (foundItem) {
      return foundItem.label;
    }
  }

  return includeAll.value ? 'All' : ''; // Fallback
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Listbox), {
    as: "div",
    "model-value": __props.context._value,
    "onUpdate:modelValue": handleChange
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ListboxButton), {
          class: _normalizeClass([
          'relative w-full cursor-default rounded-md bg-white py-2.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset sm:text-sm sm:leading-6',
          __props.context.state.validationVisible && !__props.context.state.valid
            ? 'ring-red-500 focus:ring-red-500'
            : 'ring-gray-300 focus:ring-blue-500',
        ])
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(selectedLabel.value), 1),
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_unref(ChevronUpDownIcon), {
                class: "h-5 w-5 text-gray-400",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_Transition, {
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ListboxOptions), { class: "absolute z-20 mt-1 max-h-96 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" }, {
              default: _withCtx(() => [
                (includeAll.value)
                  ? (_openBlock(), _createBlock(_unref(ListboxOption), {
                      key: 0,
                      as: "template",
                      value: ''
                    }, {
                      default: _withCtx(({ active, selected }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass([active ? 'bg-blue-600 text-white' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-3 pr-9'])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass([selected ? 'font-semibold' : 'font-normal', 'block truncate'])
                          }, "All", 2)
                        ], 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (group) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: group.groupValue
                  }, [
                    _createVNode(_unref(ListboxOption), {
                      as: "template",
                      value: group.groupValue
                    }, {
                      default: _withCtx(({ active, selected }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass([active ? 'bg-blue-600 text-white' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-8 pr-9 font-semibold'])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['block truncate', selected ? 'font-semibold' : 'font-normal'])
                          }, _toDisplayString(group.groupLabel), 3)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                      return (_openBlock(), _createBlock(_unref(ListboxOption), {
                        key: item.value,
                        value: item.value,
                        as: "template"
                      }, {
                        default: _withCtx(({ active, selected }) => [
                          _createElementVNode("li", {
                            class: _normalizeClass([active ? 'bg-blue-600 text-white' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-12 pr-9'])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(['block truncate', selected ? 'font-semibold' : 'font-normal'])
                            }, _toDisplayString(item.label), 3)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ], 64))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})